__turbopack_context__.v({
  "addButton": "TripBoundaryStay-module__wVYMPW__addButton",
  "heading": "TripBoundaryStay-module__wVYMPW__heading",
  "pendingLabel": "TripBoundaryStay-module__wVYMPW__pendingLabel",
  "removeButton": "TripBoundaryStay-module__wVYMPW__removeButton",
  "skeleton": "TripBoundaryStay-module__wVYMPW__skeleton",
  "wrapper": "TripBoundaryStay-module__wVYMPW__wrapper",
});
